export const initializePermissions = (modules, mode) => {
  return modules?.map((module) => ({
    ...module,
    isSelected: mode === 'create' ? false : true,
    submodules: module.submodules.map((submodule) => ({
      ...submodule,
      isSelected: mode === 'create' ? false : true,
      permissions: mode === 'create' ? [] : submodule.permissions,
    })),
  }));
};